// Client-side view of the description_sections column (migration 0026).
// Element shape: { body, revealed }.
//
// Deliberately separate from shared/sections.js: that one runs in the Worker,
// this bundles into the browser. They agree on the shape, not on the file.
//
// Pure and free of React/DOM so tests/description-sections.test.js can exercise
// it in Vitest's node environment — same pattern as entitySort.js and mapZoom.js.

function toSection(raw) {
  if (raw === null || typeof raw !== 'object' || Array.isArray(raw)) return null
  if (!('body' in raw)) return null
  return {
    body: typeof raw.body === 'string' ? raw.body : String(raw.body),
    revealed: raw.revealed === true || raw.revealed === 1 || raw.revealed === 'true',
  }
}

/** Always an array. Never throws — it is called during render. */
export function parseSections(value) {
  if (Array.isArray(value)) return value.map(toSection).filter(Boolean)
  if (typeof value !== 'string' || value === '') return []
  try {
    const parsed = JSON.parse(value)
    return Array.isArray(parsed) ? parsed.map(toSection).filter(Boolean) : []
  } catch {
    return []
  }
}

/**
 * Only the blocks a player may read.
 *
 * The server already strips these from player GETs, but "view as player" is a
 * frontend-only toggle — the server still sends hidden blocks to a previewing
 * admin, so read-only rendering filters here as well.
 */
export function visibleSections(sections) {
  return (Array.isArray(sections) ? sections : []).filter((s) => s.revealed)
}

export function serializeSections(sections) {
  return JSON.stringify(sections)
}

export function emptySection() {
  return { body: '', revealed: false }
}
